import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { requestPaymentInfo } from 'requests/payments'
import { codeFormat } from 'utils/format'
import { ApiErrors } from 'ui-components/ApiErrors'
import { Top } from './components/Top'
import { Items } from './components/Items'
import { Totals } from './components/Totals'
import {
  Container,
  Cupom,
  Separator,
  Footer,
} from './styles'

export default function Print() {
  const [loading, setLoading] = useState(true)
  const [payment, setPayment] = useState({ attributes: {} })
  const [responseError, setResponseError] = useState()
  const [toPrint, setToPrint] = useState(false)

  const { id } = useParams()

  useEffect(() => {
    (async function getPaymentInfo() {
      const response = await requestPaymentInfo(id)

      setLoading(false)
      if (response.error) return setResponseError(response)

      setToPrint(true)
      return setPayment(response.data)
    }())
  }, [id])

  useEffect(() => {
    if (!toPrint) return

    setTimeout(() => {
      window.print()
      window.close()
    }, 400)
  })

  const renderErrorMessage = () => (
    <ApiErrors responseError={responseError} />
  )

  const customerDescription = () => {
    const { id: customerId, name } = payment.attributes.customer || {}
    return [codeFormat(customerId), name].join(' - ')
  }

  return loading ? (
    <Container>
      <div>
        Preparando impressão...
      </div>
    </Container>
  ) : (
    <Container>
      <Cupom>
        <Separator />
        AQUARIUM LIFE
        <Separator />

        <Top payment={payment} />
        <Separator />

        <div>
          {`Cliente: ${customerDescription()}`}
        </div>

        <Separator />
        <Items
          ordersPaymentItems={payment.attributes.orders_payment_items}
        />
        <Separator />
        <Totals payment={payment} />

        <Separator />

        <Footer>
          TELEFONES: 11 97267-9874
        </Footer>
        <Separator />

        { renderErrorMessage() }
      </Cupom>
    </Container>
  )
}
